import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { BaseService }   from '../../shared-service/base.service';
import { SharingPanelService }   from '../../shared-service/sharing-panel-service';
import { WidgetItem } from '../../shared-datatypes/widget-items';
import { Widgets } from './widgets/widgets'


@Component({
	selector: 'app-overview',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './overview.component.html',
	styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit, OnDestroy {

	L1!: WidgetItem;
	R1!: WidgetItem;
	R2!: WidgetItem;
	M1!: WidgetItem;
	widgets: object|any = {};
	show: boolean = false;

	constructor(public bs: BaseService, private router: Router, private route: ActivatedRoute,public sps: SharingPanelService) {
		this.widgets = new Widgets().widgets;
		/* Initializing Panel */
		this.sps.updateComponentObj(this.widgets['CustomizePanelComponent'], {show: false});
	}

	ngOnInit() {
		this.bs.log('info',"ngOnInit OverviewComponent");
		this.route.params.subscribe((qParams)=>{
			if(Object.keys(qParams).length) {
				console.log("reload overview", qParams);
				this.L1 = new WidgetItem(this.widgets['UpcomingtrainingsComponent'], {typeName: 'L1'});
				this.R1 = new WidgetItem(this.widgets['UpcomingeventComponent'], {typeName: 'L1'});
				this.R2 = new WidgetItem(this.widgets['MytasksComponent'], {typeName: 'R2'});
				this.M1 = new WidgetItem(this.widgets['TimelineComponent'], {typeName: 'M1'});
			}
		});
	}

	customizePanel() {
		if (this.show) {
			this.show = false;
			this.sps.updateComponentObj(this.widgets['CustomizePanelComponent'], {show: false});
		} else {
			this.show = true;
			this.sps.updateComponentObj(this.widgets['CustomizePanelComponent'], {show: true});
		}
	}

	onDragOver(ev: Event) {
		ev.preventDefault();
	}

	onDrop(ev: Event|any, wLoc: string) {
		console.log(ev);
		ev.preventDefault();
		let tmp = ev['dataTransfer'].getData("text").split('-');
		let updated = tmp[0];
		if (tmp[1] == 'sw') {
			switch (wLoc) {
				case "L1":
					console.log("replace L1 with "+updated);
					if (this.L1.component['name'] != updated) {
						this.L1 = new WidgetItem(this.widgets[updated], {typeName: wLoc});
					}
					break;
				case "R1":
					console.log("replace R1 with "+updated);
					if (this.R1.component['name'] != updated) {
						this.R1 = new WidgetItem(this.widgets[updated], {typeName: wLoc});
					}
					break;
				case "R2":
					console.log("replace R2 with "+updated);
					if (this.R2.component['name'] != updated) {
						this.R2 = new WidgetItem(this.widgets[updated], {typeName: wLoc});
					}
					break;
				default:
					console.log("Middle widget cannot be dropped here");
					break;
			}
		} else {
			switch (wLoc) {
				case "M1":
					console.log("replace M1 with "+updated);
					if (this.M1.component['name'] != updated) {
						this.M1 = new WidgetItem(this.widgets[updated], {typeName: wLoc});
					}
					break;
				default:
					console.log("Side widget cannot be dropped here");
					break;
			}
		}
	}

	ngOnDestroy() {
		this.sps.resetPanel();
	}
}
